import type { ProblemDetails } from './types';

export const STATUS_FORBIDDEN = 403;
export const STATUS_NOT_FOUND = 404;

export function ehProibido(status: number | undefined | null) {
  return status === STATUS_FORBIDDEN;
}

export function ehNaoEncontrado(status: number | undefined | null) {
  return status === STATUS_NOT_FOUND;
}

export function ehProblemDetails(erro: unknown): erro is ProblemDetails {
  return (
    typeof erro === 'object' &&
    erro !== null &&
    'status' in erro &&
    typeof erro.status === 'number'
  );
}

/**
 * Corpo no padrão `ApiErrorResponse` (`{ errors: [...] }`). O 400 de model binding do ASP.NET
 * também tem `errors`, mas como objeto, e por isso não entra aqui.
 */
export function ehApiErrorResponse(
  erro: unknown,
): erro is { errors: { error?: string; field?: string | null }[] } {
  return (
    typeof erro === 'object' &&
    erro !== null &&
    'errors' in erro &&
    Array.isArray(erro.errors)
  );
}
